var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8914_15419)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8914_15419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.876 0.285645H0.875977V24.3014H24.876V0.285645Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8914_15419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9421 24.3016C11.1472 24.3156 9.37228 23.9232 7.7505 23.1538C7.49959 23.025 7.20804 23.0003 6.93902 23.0849C5.6761 23.4506 4.40415 23.7869 3.14123 24.1549C2.47196 24.349 1.85461 24.393 1.314 23.8434C0.773397 23.2937 0.845627 22.6685 1.03749 22.006C1.39301 20.7792 1.71466 19.5422 2.0792 18.3177C2.17774 17.9953 2.14572 17.6472 1.99004 17.3482C0.714128 14.5976 0.525885 11.4661 1.4631 8.58249C2.40031 5.69884 4.39361 3.27641 7.04286 1.80151C14.0403 -2.1272 22.9563 1.94259 24.612 9.81468C26.0442 16.6428 21.488 23.1481 14.5606 24.1831C13.9816 24.2734 13.4003 24.2598 12.9421 24.3016ZM12.6961 22.5477C19.838 22.5252 24.682 15.8404 22.5929 9.14542C20.4655 2.33084 11.8259 -0.19048 6.36907 4.40524C2.59047 7.59132 1.56569 12.687 3.83984 17.0627C3.9384 17.2303 4.0005 17.4169 4.02208 17.6102C4.04367 17.8035 4.02426 17.9992 3.96512 18.1845C3.59493 19.426 3.26876 20.681 2.90084 21.9236C2.78007 22.3322 2.87826 22.3863 3.25973 22.2746C4.52266 21.9055 5.79461 21.5726 7.05527 21.199C7.22322 21.1451 7.40078 21.1277 7.57599 21.1482C7.75121 21.1686 7.92 21.2264 8.07102 21.3175C9.48951 22.0982 11.0772 22.5205 12.6961 22.5477Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1576 9.62961C16.1576 10.2323 15.8935 10.9975 15.327 11.6476C15.0425 11.9734 14.7499 12.2909 14.4489 12.6001C14.0426 13.0177 13.7774 13.4816 13.7492 14.0888C13.7243 14.6429 13.3338 14.9996 12.8609 14.9917C12.3677 14.9826 12.0111 14.5775 11.9987 14.0041C11.9738 12.8202 12.5856 11.9433 13.3722 11.1465C13.6416 10.8855 13.8882 10.602 14.1092 10.2989C14.2949 10.0249 14.3941 9.70155 14.3941 9.37059C14.3941 9.03963 14.2949 8.71627 14.1092 8.44231C13.9413 8.20245 13.7075 8.01631 13.4362 7.90637C13.1648 7.79642 12.8674 7.76737 12.5799 7.8227C11.9027 7.96377 11.4897 8.42988 11.3599 9.19734C11.2414 9.90047 10.9084 10.23 10.3644 10.1691C9.82044 10.1081 9.52813 9.65105 9.60488 8.93664C9.7911 7.22566 11.3339 5.91307 13.0325 6.02029C14.8371 6.13202 16.1836 7.57666 16.1576 9.62961Z",
    fill: "#A0A7AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.049 17.7138C14.0485 17.9461 13.9792 18.1731 13.8498 18.366C13.7204 18.5589 13.5367 18.7092 13.3219 18.7977C13.1071 18.8863 12.8709 18.9091 12.6431 18.8635C12.4153 18.8178 12.2062 18.7056 12.0421 18.5411C11.8781 18.3766 11.7665 18.1671 11.7215 17.9392C11.6765 17.7113 11.7 17.4751 11.7892 17.2606C11.8784 17.0461 12.0291 16.8628 12.2224 16.7339C12.4157 16.6051 12.6429 16.5364 12.8752 16.5366C13.1867 16.5381 13.4849 16.6627 13.7048 16.8833C13.9247 17.1038 14.0484 17.4023 14.049 17.7138Z",
    fill: "#A0A7AF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8914_15419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.c5742050418f92fd87cb2f951e486e51.svg";
export { ForwardRef as ReactComponent };